import { constant } from "./app.constants";

// Add warning or error or success messages here
export const MsgConfig = {
    SOMETHING_WENT_WRONG: "Something went wrong. Please contact system admin.",
    INVALID_NAME_PASSW: "Please enter valid credentials.",
    LOGOUT: "You are logged out of the application. Please login to continue.",
    SAVE_SUCCESS: "Saved successfully.",
    SAVE_FAIL: "Save unsuccessful.",
    NO_DATA: "No data is available in the table to save.",
    UNABLE_TO_DEL:"Unable to delete the item.",
    UPDATE_SUCCESS: "Updated successfully.",
    UPDATE_FAIL: "Update unsuccessful.",
    DELETE_SUCCESS: "Deleted successfully.",
    REMOVE_SUCCESS: "Removed successfully.",
    DELETE_FAIL: "Delete unsuccessful.",
    REMOVE_FAIL: "Remove unsuccessful.",
    PHY_INVENTORY_PROCESS_SUCCESS:"Physical Inventory processed successfully.",
    PHY_INVENTORY_PROCESS_FAIL:"Physical Inventory processing failed.",
    PHY_INVENTORY_ADDED_SUCESS:"Physical Inventory added successfully.",
    PHY_INVENTORY_Updated_SUCESS:"Physical Inventory updated successfully.",
    INVALID_ADMIN_USER: "Logged-in user is not an Admin.",
    PASSWORD_RESET_PREVIOUS: "New password must be different from the previous 3 passwords.",
    INVALID_PWD_FORMAT: "Password didn't match the format.",
    PHARMICIST_ACCOUNT_LOCKED: "Pharmacist account is locked due to multiple failed attempts. Please contact Admin to reset your password.",
    TECHNICIAN_ACCOUNT_LOCKED: "Technician account is locked due to multiple failed attempts. Please contact Admin to reset your password.",
    MANDATORY_FIELDS: "Please fill all mandatory fields.",
    RECALL_DELETED_RX_SUCCESS: "Recall Rx successful.",
    RECALL_DELETED_RX_FAIL: "Recall Rx failed.",
    RECALL_DELETED_RX_EXIST: "Refill cannot be recalled as it is already in use.",
    IOC_CANNOT_BE_RECALLED: "Once deleted, item of concern Rx can`t be recalled.",
    CONTROL_RX_CANNOT_BE_RECALLED: "Once submitted to the state and Rx is deleted, then the control Rx cannot be recalled.",
    NO_PRIVS_ACCESS: "You do not have privilege to perform this action.",
    MEDGUIDE_NOT_AVAILABLE: "No medguide available to print!!",
    CREATE_NEW_TENAT: "New Tenant created successfully.",
    ERX_REQUEST_SUCCESS: "eRx request sent successfully.",
    ERX_REQUEST_SUBMITTED: "eRx request submitted successfully",
    ERX_CHANGE_REQ_SUCCESS: "eRx Change request sent successfully.",
    ERX_CHANGE_REQ_SUBMITTED: "eRx Change request submitted successfully.",
    ERX_REQUEST_ERROR: "Error while sending eRx request.",
    PAT_PRE_DRUG_CHECK_PAT_CREATE_FAIL: "Patient save unsuccessful.",
    PAT_PRE_DRUG_CHECK_PAT_CREATE_CANCEL: "Patient add Cancelled.",
    PAT_PRE_DRUG_CHECK_PRE_CREATE_CANCEL: "Prescriber add Cancelled.",
    PAT_PRE_DRUG_CHECK_PRE_CREATE_SUCCESS: "Prescriber saved successfully.",
    PAT_PRE_DRUG_CHECK_PRE_CREATE_FAIL: "Prescriber save unsuccessful",
    PAT_PRE_DRUG_CHECK_PRE_INVALID_INSU: "Invalid insurance restriction value..!!",
    PAT_PRE_DRUG_CHECK_DRUG_DUP_NDC: "This drug already exist in the system. Duplicate NDC code.",
    PAT_PRE_DRUG_CHECK_DRUG_DUP_QUICK: "Duplicate quick code.",
    PAT_PRE_DRUG_CHECK_DRUG_CREATE_SUCCESS: "Drug saved successfully.",
    PAT_PRE_DRUG_CHECK_DRUG_CREATE_FAIL: "Drug save unsuccessful.",
    PAT_PRE_DRUG_CHECK_NEWRX_GENER_FAIL: "Rx number generation failed.",
    COPIED_SUCCESS: "Copied successfully.",
    COPIED_UNSUCCESS: "Copy unsuccessful.",
    WRONG_MSG: "Unfortunately, there was a technical error while processing your request. Please try again. If the problem persists, please contact the support team.",
    INVALID_INSURANCE_REST: "Invalid insurance restriction value.",
    PATIENT_ALLERGY_EXISTS: "This allergy has already been assigned to the patient.",
    PRESCRIBER_SPECIALITY_EXISTS: "Prescriber specialities must be unique.",
    DUPLICATE_NCDP_PAYER_SET: "NCPDP PayerSet Id with this transaction type already exists.",
    ENTER_REQ_FIELD: "Please enter required fields.",
    PRICE_CODE_ALREADY: "Price code already exists.",
    DISCOUNT_CODE_ALREADY: "Discount code already exists.",
    PRICE_NAME_ALREADY: "Price Schedule name already exists.",
    DATE_RANGE_ERROR: "To date must be later than From date.",
    INVALID_DATES_ERROR: "Please enter valid date.",
    TO_FROM_DATES_MISSING : "Please fill both From Date and To Date.",
    INSURANCE_PATIENT_USE: "Cannot delete the insurance as it is already assigned to another patient.",
    TRANSTYPE_NAME_EXISTS: "Type name already exists.",
    TRANSTYPE_ALREADY_IN_USE: "Trans type cannot be deleted as it is already in use.",
    VENDOR_CODE_EXISTS: "Vendor Id already exists.",
    BUCKET_CODE_EXISTS: "Bucket Code already exists.",
    BUCKET_NAME_EXISTS: "Bucket Name already exists.",
    BUCKET_BOTH_EXISTS: "Bucket Name and Code already exists.",
    FACILITY_CODE_EXISTS: "Facility code already exists.",
    PATIENT_CATEGORY_CODE_EXISTS: "Category Code already exists.",
    PRESCRIBER_SPECIALITY_CODE_EXISTS: "Speciality Code already exists.",
    PATIENT_ALREADY_IN_USE: "Cannot delete the Patient as it is already assigned to Rx.",
    PRESCRIBER_ALREADY_IN_USE: "Cannot delete the Prescriber as it is already assigned to Rx.",
    DRUG_ALREADY_IN_USE: "Cannot delete the Drug as it is already assigned to Rx.",
    REPORT_GENERATION_ERROR: "Error while generating report.",
    DOCUMENTS_SAVED_SUCCESS: "Documents save successful.",
    DOCUMENTS_FAILED_SUCCESS: "Documents save unsuccessful.",
    OTHER_AMT_SAVE_TEMP: "Other amount information added. Please click Rx save.",
    FILED: "Rx Filled and saved successfully.",
    RX_SAVE: "Rx saved successfully.",
    TRANSMIT_SUCCESS: "Rx saved and Transmitted successfully.",
    MULTIPLE_USER_SAVE: "The selected Rx is currently in use by a different user on the same tenant.",
    MULTIPLE_USER_SAVE_MSG: "Unable to save Rx, as the selected Rx is currently in use by a different user on the same tenant.",
    VENDOR_ALREADY_IN_USE: "Cannot delete the Vendor as it is already in use.",
    RphVerifySuccess: "Marked Rxs are successfully verified.",
    MSG_RESENT_SUCCESS: "Message Resent successfully.",
    MSG_SENT_SUCCESS: "Message sent successfully.",
    Cancel_MSG_SUCCESS: "Sending message Cancelled successfully",
    REFILL_DUE_MSG_SUCCESS: "Refill Due Message sent successfully",
    REPORT_GENERATED_SUCCESS: "Rx By Pharmacist Report is generated successfully.",
    ASYNC_REPORT_ERROR: "The action you were trying to perform was not successful due to a technical issue on our servers. Our engineers have been informed of this issue and will work to resolve this. If you need immediate assistance with this issue, you can contact the MicroMerchant Systems support team with the following event key:",
    ADD_ATLEAST_ONE_RECORD: "Please add atleast one field.",
    ASYNC_REPORT_HOVEROVER: "is in progress, once the report is generated you can continue working on this report.",
    DATE_FORMAT:"MM/DD/YYYY",
    DATE_FORMAT_TIME:"MM/DD/YYYY hh:mm:ss a",
    DATE_FORMAT_TIME_SHORT_YEAR: "MM/DD/YY hh:mm:ss a",
    DATE_FORMAT_AtTIME:"MM/DD/YYYY [at] hh:mm:ss A",
    DATE_FORMAT_TIME_VIEW : "MM/dd/yyyy, hh:mm:ss a" ,  
    DATE_FORMAT_WITH_EIPHEN:"YYYY-MM-DD",
    DATE_TIME_FORMAT_UPPERCASE:"MM/DD/YYYY hh:mm:ss A",
    DATE_TIME_FORMAT_WITHOUT_CLOCK: "YYYY-MM-DDTHH:mm:ss",
    ALREADY_EXIST:"already exists.",
    isRejectedEligiblity:"We ran the automated Eligibility Checks with Troop and Commercial but did not find any results. If you'd like to perform additional search (Troop) by entering the Medicare ID/Policy#, please enter the same and re-transmit.",
    isCashRejectedEligiblity:"We ran the automated Eligibility Checks with Commercial but did not find any results. If you'd like to perform additional search by entering the Medicare ID/Policy#, please enter the same and re-transmit.",
    isApprovedEligiblity:"We ran the automated Eligibility Checks and updated the Insurance information results respectively.",
    TITLE_SUCCESS: "Title saved successfully.",
    Warn_Text_Header :"Warning!!",
    No_DataDisplay_Text: "No data to display!",
    Delete_Confirmation :"Are you sure you want to delete?",
    Delete_Header_Text :"Confirmation",
    Unselect_Warning :"Please select at least one record",
    Unselect_Warn :"Please select at least one record to process.",
    UnSelectFor_MultiSelect:"Please select only one record to process.",
    HOA_SAVE: "HOA configured Successfully",
    HOA_SELECT: "HOA not configured for the selected Rx's",
    USER_EMAIL_EXIST: "The User Email entered is already associated with another User",
    No_MedGuide_Print : "This setting is not applicable for Transfer In/Out and Deferred Rxs.",
    DRUG_ALREADY_ADDED : "The Selected Drug is already added, Please Select another Drug.",
    PRESCRIBER_ALREADY_ADDED : "The Selected Prescriber is already added, Please Select another Prescirber",
    PATIENT_ALREADY_ADDED : "The Selected Patient is already added, Please Select another Patient",
    PATIENT_ALLERGY_NOTEXISTS : "Please select atleast one Allergy.",
    PATIENT_ALLERGY_REMOVEALL : "Please remove all selected allergies from the list.",
    DEFAULT_NO_DATA_FOUND_WARN : "No Data Found!",
    Authorization_Required: " authorization is required.<br> Please enter credentials for authorization.", 
    EMPTY_Data: "--",
    DOT_Three_Fixed: "0.000",
    No_Known_Allergies : "No Known Allergies",
    YES_Display : "YES",
    NO_Display : "NO",
    Inactive_Patient: "Inactive Patient",
    Inactive_Prescriber: "Inactive Prescriber",
    Inactive_Drug: "Inactive Drug",
    Search_Prescriber : "Search Prescriber",
    Search_Patient : "Search Patient",
    Information_msg: "Information",
    Notes_Saved: "Notes saved successfully.",
    Immunization_Success: "Immunization files successfully submitted to the state.",
    Immunization_Error: "Failed to submit immunization file.",
    Immunization_Sub_Success: "Immunization file successfully saved and submitted to the state.",
    Immunization_Sub_Error: "Immunization file submission failed, but details were saved successfully.",
    EnterMsg: 'Enter Message',
    PleaseEnterMsg: 'Please enter a message',
    NO_Internet: "No internet connection.",
    Today:"Today",
    Yesterday:"Yesterday",
    Transfer_In_Req: " Rx Transfer Initiation is sent successfully.",
    Service_Not_Available: "This pharmacy  does not have eRx service available.",
    Delete_PA_Drug : "PA has been deleted due to drug change",
    Delete_PA_Patient : "PA has been deleted due to patient change",
    Delete_PA_Prescriber : "PA has been deleted due to prescriber change",
    Delete_PA_Insurance : "PA has been deleted due to Insurance change",
    Default_Date_Notes : "1973-01-01",
    Transfer_in_Request: "Transfer In",
    Transfer_Out: "Transfer Out",
    Transfer_In_Req_Process: "Rx Transfer Initiation Request response  sent successfully.",
    Transfer_Out_Message: "Rx Transfer Out sent successfully.",
    Transfer_In_Confirm: "Transfer In Confirmation",
    Transfer_Confirm: "Confirmation",
    RX_FILE_SIZE_EXCEEDED: "File size must not exceed 50MB.",
    Prescriber_Phone : "Prescriber phone number required",
    Prescriber_Phone_Must : "Prescriber phone must be greater than or equals to 10 digits.",
    Transfer_eRx_Msg : "The prescription cannot be selected until the associated",
    Multi_Store_Reporting : "Multi-Location Reporting",
    Multi_Store_Reporting_Placeholder : "Select pharmacies to view grouped report",
    Inactive_Expired_Rxs_Restrction : "Inactive/Expired Rxs cannot be transferred.",
    Add_Record_First : "This action is disabled until a record is added.",
    Service_Not_Available_Without_NPI: "This pharmacy does not have an NPI, so we cannot process a transfer-in without it.",
    Multi_Location_Privilege_Tooltip : "The user does not have the required privilege to select pharmacies.",
    MP_Select_vendor:"Please select atleast one reminder.",
    MP_Qty_ByNDC:"Total Qty in Cart by NDC ({NDC}) is {count}",
    MP_Unique_Qty:"Total unique NDC items added to the cart.",
    MP_Drug_nFound: "Drug not found in PrimeRx Market.",
    MP_Best_Price:"Best Price by NDC : {price}",
    MP_In_Cart_Price:"In Cart Price : {price}",
    MP_Data_Loading:"Data Loading...",
    MP_Drug_Pharmacy_Not_Reg: "This pharmacy is not registered with PrimeRx Market.",
    Extention_Valid : "The specified extension already exists. Please select a unique number",
    QR_MISSING_REQUIRED_CTRL_SUBSTANCES:"is required for controlled substances. Please update the information.",
    API_LIST_TO_SHOW_SERVER_ERROR: constant.PUT_Rx_QuickRefill,
    IVR_Call_Error:"IVR call could not be initiated. Please check the configured phone number or try again later",
    IVR_Deactivate_Msg : "The IVR system is currently deactivated. Please activate it in Account Settings.",
    Phone_Must : "Phone must be greater than or equals to 10 digits.",
    Select_Reason_Transfer: "Please select the reason for denying the transfer request.",
    zero_not_valid: "Please enter a quantity greater than zero.",
    Call_Ongoing_Msg: "A call is currently in progress. Please end the call before proceeding.",
    Call_Status_Error: "This workstation's extension is not engaged in any active call at the moment.",
    Multi_location_View: "Select pharmacies or stores to view data",
    Multi_Location_Grand_Totals: "Multi-Location Grand Totals",
    Multi_Location_Pharmacy_Totals: "Pharmacy Totals",
    No_Rx_Selected: "Please select atleast one Rx.",
    Verification_Msg: "verification could not be completed for the following Rx(s) due to the reasons below:",
    Print_Msg: "Printing could not be performed due to a network error. Please contact support.",
    POS_Paid_Transaction_Msg: "Paid transaction detected. Please Return the transaction in POS before deleting the record.",
    Doc_Added_to_Patient:"Image successfully attached to {Pat_name}'s documents.",
    Doc_Added_to_Rx:"Image successfully attached to Rx# {Rx_number}.",
    Resend_Fax_button_Tooltip: "Resends the fax to the recipient with the most recent updates.",
    Min_Date_Value: "0001-01-01T00:00:00",
    Resend_Fax_Without_Selecting: "Please select atleast one fax to resend.",
    Logicoy_Load_Timeout_MS: 6000,
    BambooHealth_Load_Timeout_MS: 4000,
    Expt_Date_Less_Than_Ord_Date: "Expiration Date cannot be less than Ordered Date.",
    Expt_Date_Less_Than_Fill_Date: "Expiration Date cannot be less than Fill Date.",
    Fill_Date_Less_Than_Ord_Date: "Fill Date cannot be less than Ordered Date.",
    Duplicate_ExternalHistory: "A prescription with the same Rx number and source pharmacy already exists in the external history.",
    Please_Fill_All_Mandatory_Fields: "Please fill all mandatory fields.",
    Please_Select_Patient_Info : "Please select patient information.",
    Please_Select_Prescriber_Info : "Please select prescriber information.",
    Please_Select_Drug_Info : "Please select drug information.",
    Please_Select_atleast_One_Rx : "Please select at least one Rx.",
    Please_select_only_error_Rx : "Please select only refill requests with error status.",
    Scanner_DynamsoftIsOutDated: "Your current scanner driver version is outdated. \nPlease update latest version."
};
